import { createSelector } from '@reduxjs/toolkit';

import { eventPaymentsKey, EventPaymentsState } from '@/store/event-payment/event-payment.actions';

export const selectSelectedTickets = createSelector(
    (state: { [eventPaymentsKey]: EventPaymentsState }) => state[eventPaymentsKey],
    (state: EventPaymentsState) => state.selectedTickets,
);
